export default __webpack_public_path__ + "static/media/solucao-02.de156f29.webp";